export const INTELLIGENCE_TAB = {
  value: 'other',
  label: 'Intelligence',
} as const;

export const SUPPLEMENTAL_LAYER_CATEGORIES = [
  { value: 'local_gis', label: 'Local GIS' },
  { value: 'weather', label: 'Weather' },
  { value: 'responder', label: 'Responder' },
  INTELLIGENCE_TAB,
] as const;
